<!-- 线上考试 -->
<template>
  <div class="onLineExam">
    <el-row class="tableHearInputBox" type="flex" justify="end">
      <el-col >
        <el-input
            v-model.trim="query.query"
            placeholder="请输入考生姓名"
            style="width: 220px"
            @keyup.enter.native="tableLoad"
            @clear="
              query.query = '';
              query.pageNum=1;
              tableLoad();
            "
            clearable
            suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin:0px 10px" size="small" @click="query.pageNum=1;
              tableLoad();"
          >查询</el-button
          >
        </Debounce>
        <el-select v-model="query.provinceId" @change="provincesSelectChange" filterable placeholder="请选择">
          <el-option label="全部省份" value= ""></el-option>
          <el-option v-for="item in provincesSelectList" :key="item.provinceId" :label="item.provinceName" :value="item.provinceId"></el-option>
        </el-select>
        <el-select v-model="query.examSiteId" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部市代" value= ""></el-option>
          <el-option v-for="item in examSiteSelectList" :key="item.examSiteId" :label="item.examSiteName" :value="item.examSiteId"></el-option>
        </el-select>
        <el-select v-model="query.subjectLevel" @change="tableLoad" style="width: 120px" filterable placeholder="请选择">
          <el-option label="全部等级" value= ""></el-option>
          <el-option v-for="item in leveSelectList" :key="item.subjectLevel" :label="item.subjectLevelName" :value="item.subjectLevel"></el-option>
        </el-select>
      </el-col>
      <template v-if="$roleFilter('arrange:plan')" >
        <Debounce>
          <el-button type="primary" @click="operatInfo" size="small">
            安排考场
          </el-button>
        </Debounce>
      </template>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" :height="$store.getters.getTableHeight - 50">
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column label="性别" align="center">
        <template slot-scope="{row}">
          {{row.sex==1?'男':'女'}}
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄"  align="center"></el-table-column>
      <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
      <el-table-column prop="examSiteName" label="考点" align="center"></el-table-column>
      <el-table-column prop="registerName" label="报名点" align="center"></el-table-column>
      <el-table-column label="报考等级" align="center">
        <template slot-scope="{row}">
          {{row.level | getLvTextByLv}}
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content" @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents" title="安排考场" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="900px">
      <ExamRoomFrom v-if="visible" :examId="query.examId" @goBack="goBack" />
    </el-dialog>
  </div>
</template>

<script>
import ExamRoomFrom from "@/views/admin/examInfoManagement/examArrangement/examRoomFrom";
export default {
  name:'notScheduled',
  components:{
    ExamRoomFrom,
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: false,
      provincesSelectList:[],//省份下拉
      examSiteSelectList:[],//考点下拉
      leveSelectList:[],//报考等级
      visible: false,
      visibleType: 0, //删除
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        provinceId:'',//省份id
        examSiteId: "",//考点编号
        subjectLevel:'',
        examRoomId:'',//考场id
        examId:'',
      },
    };
  },
  created() {
    this.query.examId=this.$route.query.id;
  },
  mounted() {
    this.getAllSelectList()
    this.tableLoad();
  },
  methods: {
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post("/arrange/detail/0", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    operatInfo() {
      this.visible = true;
    },
    getAllSelectList(){
      this.$axios.get("/arrange/select").then((res) => {
        const data = res.data.data;
        this.provincesSelectList=data;
      });
      this.$axios.get("/arrange/levelSelect").then((res) => {
        const data = res.data.data;
        this.leveSelectList=data;
      });
    },
    provincesSelectChange(val){
      this.query.examSiteId='';
      this.tableLoad();
      //如果选择全部省份
      if(!val){
        this.examSiteSelectList=[]
        return
      }
      this.examSiteSelectList=this.provincesSelectList.find(item=>item.provinceId===val).examSiteVOS;
    },
    goBack(){
      this.visible=false;
      this.tableLoad()
    }
  },
};
</script>
<style lang="scss">
.onLineExam {
  .tableHearInputBox{
    .el-select{
      margin-right: 10px;
    }
  }
  .dailogComponents {
    .el-table td div,
    td {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  .el-button--text {
    text-decoration: underline;
  }
}
</style>
